module.exports = __webpack_public_path__ + "img/thank-you.eb783f95.svg";